import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  FormTextarea,
  Button
} from "shards-react";

// this is where USER can change is profile // code name Sierra

// const userPicture = sessionStorage.getItem("userimage")

//const userSurname = sessionStorage.getItem("usersurname")
//const userEmail = sessionSto

class UserAccountDetails extends React.Component {
  state = {
    userName: "",
    userSurname: "",
    userEmail: "",
    userPicture: "",
    userPassword : '',
    userdescription : ''
  }

  submit = event => {
    console.log("submit", event);
    console.log("data", this.state);
    this.OnUserChange(this.state)
  }

  OnUserChange = async data => {
    const userID = sessionStorage.getItem("userID")
    data.id = userID;
    var Userchanged = JSON.stringify(data);
    console.log(Userchanged);
    const response = await fetch(`https://expressgenetator.herokuapp.com/users/userchange`, {
      method: "POST",
      body: Userchanged,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });
  
    if (response.status === 200) {
      console.log("Ok user have been updated");
      console.log("you need to relogin");
      sessionStorage.clear(); 
      window.location.reload()
    
    } else {
      console.error(
        "The server didn't accept your registration, Maybe the server is offline"
      );
    }
  };

  render() {
    return (
      <Card small className="mb-4">
        <CardHeader className="border-bottom">
          <h6 className="m-0">{this.props.title}</h6>
        </CardHeader>
        <ListGroup flush>
          <ListGroupItem className="p-3">
            <Row>
              <Col>
                <Form onSubmit={this.submit}>
                  <Row form>
                    {/* First Name */}
                    <Col md="6" className="form-group">
                      <label htmlFor="feFirstName">First Name</label>
                      <FormInput
                        id="feFirstName"
                        placeholder="First Name"
                        value={this.state.userSurname}
                        onChange={event => {
                          this.setState({
                            userSurname: event.target.value
                          });
                        }}
                        required
                      />
                    </Col>
                    {/* Last Name */}
                    <Col md="6" className="form-group">
                      <label htmlFor="feLastName">Last Name</label>
                      <FormInput
                        id="feLastName"
                        placeholder="Last Name"
                        value={this.state.userName}
                        onChange={event => {
                          this.setState({
                            userName: event.target.value
                          });
                        }}
                        required
                      />
                    </Col>
                  </Row>
                  <Row form>
                    {/* Email */}
                    <Col md="6" className="form-group">
                      <label htmlFor="feEmail">Email</label>
                      <FormInput
                        type="email"
                        id="feEmail"
                        placeholder={this.state.userEmail}
                        value={this.state.userEmail}
                        onChange={event => {
                          this.setState({
                            userEmail: event.target.value
                          });
                        }}
                        autoComplete="email"
                        required
                      />
                    </Col>
                    {/* Password */}
                    <Col md="6" className="form-group">
                      <label htmlFor="fePassword">Password</label>
                      <FormInput
                        type="password"
                        minLength="8"
                        id="fePassword"
                        placeholder={this.state.userPassword}
                        value={this.state.userPassword}
                        onChange={event => {
                          this.setState({
                            userPassword: event.target.value
                          });
                        }}
                        autoComplete="current-password"
                        required
                        
                      />
                    </Col>
                  </Row>
                  <FormGroup>
                    <label htmlFor="feAddress">Picture Profile</label>
                    <FormInput
                      id="feAddress"
                      placeholder="User Profile"
                      value={this.state.userPicture}
                      type="url"
                      onChange={event => {
                        this.setState({
                          userPicture: event.target.value
                        });
                      }}
                      required
                    />
                  </FormGroup>
                  <Row form>
                    {/* Description */}
                    <Col md="12" className="form-group">
                      <label htmlFor="feDescription">Description</label>
                    
                      
                      <FormTextarea value={this.state.userdescription} id="feDescription" rows="5"   onChange={event => {
                        this.setState({
                          userdescription: event.target.value
                        });
                      }} />
                    </Col>
                  </Row>
                  <Button theme="accent">Update Account</Button>
                </Form>
              </Col>
            </Row>
          </ListGroupItem>
        </ListGroup>
      </Card>
    );
  }
}

UserAccountDetails.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string
};

UserAccountDetails.defaultProps = {
  title: "Account Details"
};

export default UserAccountDetails;
